import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { CATERING_OPTIONS_ACTIONS } from "../../../../redux/cateringOptions/actions";
import CateringOptionsForm from "../../../forms/CateringOptionsForm";
import {
  selectActiveCateringOption,
  selectActiveCateringOptionPeriods
} from "../../../../redux/cateringOptions/selectors";
import { PERIODS_ACTIONS } from "../../../../redux/periods/actions";
import { selectPeriods } from "../../../../redux/periods/selectors";

class CateringOptionsEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this._handleSubmit = this._handleSubmit.bind(this);
  }

  static propTypes = {
    loadCateringOptions: PropTypes.func,
    updateRequest: PropTypes.func,
    match: PropTypes.object,
    loadCateringOption: PropTypes.func,
    loadPeriods: PropTypes.func,
    event: PropTypes.object,
    cateringOption: PropTypes.object,
    periods: PropTypes.array,
    cateringPeriods: PropTypes.array
  };

  UNSAFE_componentWillMount() {
    const cateringId = this.props.match.params.cateringId;

    this.props.loadCateringOption(cateringId);
    this.props.loadPeriods(
      {
        "page[number]": 1,
        "page[size]": 50
      },
      this.props.event.id
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {}

  _handleSubmit(values) {
    const data = {
      name: values.name,
      cost: Math.round(parseFloat(String(values.cost).replace(",", ".")) * 100),
      costNoShow: Math.round(
        parseFloat(String(values.costNoShow).replace(",", ".")) * 100
      ),
      eventId: this.props.event.id,
      periods: values.periods.map(period => {
        return {
          startsAt: period.start.format("YYYY-MM-DD"),
          endsAt: period.end.format("YYYY-MM-DD"),
          relatedDays: period.relatedDays,
          relatedPeriodId: period.relatedPeriodId
        };
      })
    };

    this.props.updateRequest(values.id, data, this.props.event.id);
  }

  render() {
    const { event, cateringOption, periods, cateringPeriods } = this.props;

    return (
      <div className="row">
        <div className="col-xl-12">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon">
                    <i className="flaticon-information" />
                  </span>
                  <h3 className="m-portlet__head-text">CateringOption Info</h3>
                </div>
              </div>
            </div>
            <CateringOptionsForm
              onSubmit={this._handleSubmit}
              event={event}
              cateringOption={cateringOption}
              periods={periods}
              cateringPeriods={cateringPeriods}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function(state, props) {
  return {
    cateringOption: selectActiveCateringOption(state),
    periods: selectPeriods(state),
    cateringPeriods: selectActiveCateringOptionPeriods(state)
  };
};

const mapDispatchToProps = dispatch => ({
  updateRequest: (id, values, eventId) =>
    dispatch(CATERING_OPTIONS_ACTIONS.updateRequest(id, values, eventId)),
  loadCateringOption: id => dispatch(CATERING_OPTIONS_ACTIONS.loadRequest(id)),
  loadPeriods: (filters, eventId) =>
    dispatch(PERIODS_ACTIONS.loadAllRequest(filters, eventId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CateringOptionsEdit);
